module.exports = __webpack_public_path__ + "img/icon_4_8.e6e47c91.png";